module.exports = __webpack_public_path__ + "img/icon-go-course.fd1d83ce.png";